import React, { useContext } from 'react';
import VerticalDots from 'mdi-react/DotsVerticalIcon';
import Dropdown from '@prisjakt/ui-dropdown-new';
import { AppContext } from '@prisjakt/ui-app-context';

import { EditFunctions } from '../sharedTypes';
import { ListItemFragment } from '../../../../types';

import * as S from './styles';

type Props = {
  item: ListItemFragment;
  canEdit: boolean;
} & EditFunctions;

type OptionsTypes = {
  name: string;
  value: Options.LIST_REMOVE | Options.CREATE_ALERT | Options.LIST_EDIT;
};

enum Options {
  LIST_REMOVE = 'LIST_REMOVE',
  CREATE_ALERT = 'CREATE_ALERT',
  LIST_EDIT = 'LIST_EDIT',
}

const EditControl = ({
  item,
  createAlert,
  onDelete,
  onEdit,
  canEdit,
}: Props) => {
  const { t } = useContext(AppContext);

  const options = [
    {
      name: t('alerts', 'list.remove'),
      value: Options.LIST_REMOVE,
    },
    {
      name: t('product', 'alert.create-button'),
      value: Options.CREATE_ALERT,
    },
    {
      name: t('common', 'button.edit'),
      value: Options.LIST_EDIT,
    },
  ];

  return (
    <S.Edit>
      <Dropdown
        variant="secondary"
        showArrow={false}
        toggleElement={
          <S.EditButton>
            <VerticalDots />
          </S.EditButton>
        }
        grow="left"
      >
        {options
          .filter(x => x)
          .map((option: OptionsTypes) => {
            switch (option.value) {
              case Options.LIST_REMOVE: {
                if (onDelete) {
                  return (
                    <S.EditOption
                      key={option.value}
                      type="button"
                      onClick={() => {
                        onDelete(
                          item.id,
                          ((item.__typename === 'AlertProduct' ||
                            item.__typename === 'ListProduct') &&
                            item.product &&
                            item.product.id) ||
                            undefined
                        );
                      }}
                    >
                      {option.name}
                    </S.EditOption>
                  );
                }

                break;
              }
              case Options.LIST_EDIT: {
                if (
                  (item.__typename === 'ListProduct' ||
                    item.__typename === 'ListSearch' ||
                    item.__typename === 'AlertProduct') &&
                  onEdit &&
                  canEdit
                ) {
                  return (
                    <S.EditOption
                      key={option.value}
                      type="button"
                      onClick={() => {
                        onEdit(item);
                      }}
                    >
                      {option.name}
                    </S.EditOption>
                  );
                }

                break;
              }
              case Options.CREATE_ALERT: {
                if (item.__typename === 'ListProduct' && createAlert) {
                  return (
                    <S.EditOption
                      key={option.value}
                      type="button"
                      onClick={() => {
                        createAlert(item.product);
                      }}
                    >
                      {option.name}
                    </S.EditOption>
                  );
                }

                break;
              }
              default:
                return null;
            }
            return null;
          })}
      </Dropdown>
    </S.Edit>
  );
};

EditControl.defaultProps = {
  canEdit: false,
};

export default EditControl;
